import { createApp, h } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus, { ElConfigProvider } from 'element-plus'
import en from 'element-plus/es/locale/lang/en'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import './assets/css/common.css'
import './assets/css/element-plus-compat.css'
import './assets/css/element-icons/icon.css'
import vfilters from './util/vfilters'
import './util/isRefun'
import { formatDateTime } from './util/commonality'
import i18n from './lang/i18n'
import { initApiKey } from './servies/config'
import { createEventBus } from './util/eventBus'
import { setDialogAppContext } from './util/openDialog'
import CompatibleDatePicker from './components-new/common/CompatibleDatePicker'
import { registerLegacyIcons } from './util/legacyIcons'
import RouteView from './components-new/common/RouteView.vue'
import { FILE_CDN_ORIGIN, fileCdnUrl } from './util/fileCdn'

window.$eventBus = createEventBus()
window.__FILE_CDN_ORIGIN__ = FILE_CDN_ORIGIN
window.__fileCdnUrl__ = fileCdnUrl

const serverXHR = new XMLHttpRequest()
serverXHR.open('GET', '/', false)
serverXHR.onreadystatechange = function () {
  if (serverXHR.readyState === 4) {
    sessionStorage.setItem('serverDate', new Date(serverXHR.getResponseHeader('Date')).getFullYear() || '')
  }
}
serverXHR.send(null)

initApiKey()

const app = createApp({
  computed: {
    elementLocale() {
      return i18n.global.locale === 'zh-CN' ? zhCn : en
    }
  },
  render() {
    return h(ElConfigProvider, { locale: this.elementLocale }, { default: () => h(App) })
  }
})

app.config.globalProperties.$eventBus = createEventBus()
app.config.globalProperties.$filters = { ...vfilters, formatDateTime }
app.config.globalProperties.$FILE_CDN_ORIGIN = FILE_CDN_ORIGIN
app.config.globalProperties.$fileCdnUrl = fileCdnUrl
app.config.globalProperties.$set = (target, key, value) => (target[key] = value)
app.config.globalProperties.$delete = (target, key) => {
  if (Array.isArray(target) && /^\d+$/.test(String(key))) target.splice(Number(key), 1)
  else delete target[key]
}
app.use(store)
app.use(i18n)
app.use(ElementPlus)
app.component('el-date-picker', CompatibleDatePicker)
app.component('RouteView', RouteView)
registerLegacyIcons(app)
setDialogAppContext(app._context)
app.use(router)
app.mount('#app')

export default app
